import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function TransferEmployeeOffboardingStoreRolesService(token, data) {
    return axios.post(`${CURRENT_API_URL}/account/transferEmployeeOffboardingStoreRoles`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        return res.data;
    }).catch(error => {
        console.log(error)
        notify.NotifyError("An error occurred while updating store roles, please try again later.");
        return false;
    });
}
export default TransferEmployeeOffboardingStoreRolesService
